import { render, staticRenderFns } from "./StudentsChatPanel.vue?vue&type=template&id=73755985&scoped=true"
import script from "./StudentsChatPanel.vue?vue&type=script&lang=js"
export * from "./StudentsChatPanel.vue?vue&type=script&lang=js"
import style0 from "./StudentsChatPanel.vue?vue&type=style&index=0&id=73755985&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73755985",
  null
  
)

export default component.exports